import { mapState } from 'vuex';

export const CheckPermission: any = {
  props: {
    permissions: {
      type: [String, Array],
      required: true
    },
    joinType: {
      type: String,
      required: false,
      default: 'AND'
    },
    entityId: {
      type: [String, Number],
      required: false
    },
    entityType: {
      type: String,
      required: false
    }
  },
  computed: {
    toCheck() {
      const toCheck: string[] = Array.isArray(this.permissions) ? this.permissions : [this.permissions];
      if (this.entityId && this.entityType) {
        return toCheck.map(permission => `${permission}:${this.entityType}:${this.entityId}`);
      }
      return toCheck;
    },
    ...mapState({
      hasPermission(state: any) {
        const checkedPermissions = state.access.checked;
        switch (this.joinType) {
          case 'OR':
            return this.toCheck.some((permission: string) => !!checkedPermissions[permission]);
          case 'AND':
            return this.toCheck.every((permission: string) => !!checkedPermissions[permission]);
          default:
            return false;
        }
      }
    })
  } as any,
  beforeMount() {
    this.$store.dispatch('access/check', this.toCheck);
  },
  render() {
    if (this.hasPermission) {
      return this.$scopedSlots.default({});
    }
  }
};
